<template>
	<div>
		<div class="heading">
			<p>Snippets</p>
			<router-link tag="button" class="btn btn-green" :to="{ name: 'new', params: {type: 'snippet'}}">
				New Snippet
			</router-link>
		</div>
		<div class="content snippets">
			<table class="list" cellpadding="0" cellspacing="0" width="100%">
				<thead class="list-heading">
					<tr>
						<th>
							<button class="btn btn-icon" @click="sortby('Id')">
								Id <font-awesome-icon
									v-if="sortedBy === 'Id'"
									:icon="['fas', sortDirection === 'asc' ? 'sort-up' : 'sort-down']"></font-awesome-icon>
							</button>
						</th>
						<th>
							<button class="btn btn-icon" @click="sortby('Name')">
								Name <font-awesome-icon
									v-if="sortedBy === 'Name'"
									:icon="['fas', sortDirection === 'asc' ? 'sort-up' : 'sort-down']"></font-awesome-icon>
							</button>
						</th>
						<th>
							<button class="btn btn-icon" @click="sortby('Placeholder')">
								Placeholder <font-awesome-icon
									v-if="sortedBy === 'Placeholder'"
									:icon="['fas', sortDirection === 'asc' ? 'sort-up' : 'sort-down']"></font-awesome-icon>
							</button>
						</th>
						<th>
							<button class="btn btn-icon" @click="sortby('Category')">
								Category <font-awesome-icon
									v-if="sortedBy === 'Category'"
									:icon="['fas', sortDirection === 'asc' ? 'sort-up' : 'sort-down']"></font-awesome-icon>
							</button>
						</th>
						<th align="center"><p>Status</p></th>
						<th align="center"><p>Actions</p></th>
					</tr>
				</thead>
				<tr v-for="(snippet, i) in snippets"
				:key="i"
				:class="[`cat-${snippet.Category}`, `cat${categories[snippet.Category]}`, 'list-item']">
					<td class="list-item-id"><p>{{snippet.Id}}</p></td>
					<td class="list-item-grow" style="position:relative">
						<router-link tag="button" class="btn btn-icon" :to="{name: 'snippet', params: { id: snippet.Id }}">
							{{snippet.Name}}
						</router-link>
                        <small v-if="snippet.Static == '1'" style="color:#4a8b68;position:absolute;top:8px;right:5px;">static</small>
					</td>
					<td class="list-item-placeholder"><p>{{snippet.Placeholder}}</p></td>
					<td class="list-item-cat">
						<p>
							<span
								:class="[
									`cat${categories[snippet.Category]}`,
									`cat-${snippet.Category}`
								]"
								style="font-size:350%;line-height:10px;vertical-align: middle;">&bull;</span> {{ snippet.Category }}
						</p>
					</td>
					<td class="list-item-status">
						<div class="togglecheckbox">
							<span :class="['toggle-icon', snippet.Status == 1 ? 'checked' : '']" @click="toggleicon(snippet)"></span>
						</div>
					</td>
					<td class="list-item-action">
						<router-link tag="button" class="btn btn-icon" :to="{name: 'snippet', params: { id: snippet.Id }}">
							<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>
						</router-link>
						<button class="btn btn-icon" @click.prevent="askModalDeleteSnippet(snippet)">
							<font-awesome-icon :icon="['far', 'trash-alt']"></font-awesome-icon>
						</button>
					</td>
				</tr>
			</table>
			<transition name="fade" mode="out-in">
				<div v-if="activeModal" @click.self="closemodal($event)" class="full-screen-wrapper">
					<Modal @modalResponse="modalResponse" :note="note" :message="message"></Modal>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
import Modal from '../components/Modal.vue'
export default {
	components: {
		Modal
	},
	data () {
		return {
			active: false,
			activeModal: false,
			message: '',
			note: '',
			sortedBy: 'Id',
			sortDirection: 'asc'
		}
	},
	methods: {
		modalResponse (val) {
			if (val.resp === true) {
				this.$store.dispatch('Snippets/deleteSnippet', val.note)
				this.activeModal = false
			} else {
				this.activeModal = false
			}
		},
		closemodal (e) {
			e.stopPropagation()
			this.activeModal = false
		},
		askModalDeleteSnippet (item) {
			this.message = 'Delete Snippet ' + item.Name + ' ?'
			this.note = item.Id
			this.activeModal = true
		},
		deleteSnippet (id) {
			this.$store.dispatch('Snippets/deleteSnippet', id)
		},
		sortby (value) {
			if (this.sortedBy === value) {
				this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
			}
			this.sortedBy = value
			this.snippets.sort((a, b) => {
				// asc direction
				if (this.sortDirection === 'asc') {
					if (value === 'Id') {
						return a[value] - b[value]
					}
					if (a[value].toLowerCase() < b[value].toLowerCase()) {
						return -1
					}
					if (a[value].toLowerCase() > b[value].toLowerCase()) {
						return 1
					}
					return 0
				}
				// desc direction
				// by Id
				if (value === 'Id') {
					return b[value] - a[value]
				}
				// by other properties (== string)
				if (b[value].toLowerCase() < a[value].toLowerCase()) {
					return -1
				}
				if (b[value].toLowerCase() > a[value].toLowerCase()) {
					return 1
				}
				// same texts
				return 0
			})
		},
		toggleicon (val) {
			let newstatus
			if (val.Status === '1') {
				newstatus = '0'
			} else {
				newstatus = '1'
			}
			let payload = {
				Id: val.Id,
				Status: newstatus,
			}
			this.$store.dispatch('Snippets/toggleSnippetStatus', payload)
			val.Status = newstatus;
		}
	},
	computed: {
		snippets () {
			return this.$store.getters['Snippets/getSnippets']
		},
		categories () {
			const x = {}
			if (this.snippets.length) {
				let i = 0
				for (let s in this.snippets) {
					if (this.snippets[s].Category in x) {
						continue
					} else {
						i++
						x[this.snippets[s].Category] = i
					}
				}				
			}
			return x
		}
	},
	created() {
		this.$store.dispatch('Snippets/fetchSnippets')
	}
}
</script>
<style lang="scss">
</style>
